module.exports = __webpack_public_path__ + "static/media/0004.86350663.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48106/RAL/0004.png
// module id = 2537
// module chunks = 0